<template>
  <div class="p-3 fixed-bottom cookie-alert w-100 text-center text-white" v-if="!cookieAccepted">
    This website uses cookies; by using it, you agree to our
    <router-link :to="{name: 'privacy'}" class="mr-2 text-white dashed-link">privacy policy</router-link>
    <button class="btn btn-sm btn-theme" v-on:click="acceptCookie">Okay</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cookieAccepted: localStorage.getItem('cookieAccepted') === 'true'
    }
  },
  methods: {
    acceptCookie() {
      this.cookieAccepted = true
      localStorage.setItem('cookieAccepted', true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/variables";

.cookie-alert{
  box-shadow: $e-shadow;
  background-color: rgba(#000, 0.8);
}
</style>
